<template>
    <div>
        <!-- Modal Overlay -->
        <div v-if="showSessionWarning" class="modal-overlay">
            <div class="modal-dialog" @click.stop>
                <h2>Session Timeout Warning</h2>
                <p style="text-align: center;">Your session will expire in:</p>
                <div class="countdown-display">{{ countdownFormatted }}</div>
                <p>Click "Continue" to keep working, or "Log Out" if you are finished.</p>
                <div class="button-container">
                    <button @click.stop="refreshSession" class="btn-primary">Continue</button>
                    <button @click.stop="endSession" class="btn-secondary">Log Out</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MHISessionTimeout",
        data() {
            return {
                sessionTimeout: 20 * 60,
                countdownSeconds: 60,
                countdown: 60,
                showSessionWarning: false,
                countdownIntervalId: null,
                promptTimeoutId: null,
                activityListenersActive: true  // Track if listeners should be active
            };
        },
        computed: {
            countdownFormatted() {
                const minutes = Math.floor(this.countdown / 60);
                const seconds = this.countdown % 60;
                const minutesDisplay = minutes === 1 ? '1 minute ' : minutes === 0 ? '' : minutes + ' minutes ';
                const secondsDisplay = seconds === 1 ? '1 second' : seconds + ' seconds';
                return minutesDisplay + secondsDisplay;
            }
        },
        methods: {
            endSession() {
                console.log('Ending session'); // Debug log
                this.activityListenersActive = false; // Disable activity listeners
                this.clearTimers();
                this.showSessionWarning = false;
                window.location.href = "/portal";
            },
            displayCountdown() {
                // Clear any existing countdown interval first!
                if (this.countdownIntervalId) {
                    clearInterval(this.countdownIntervalId);
                    this.countdownIntervalId = null;
                }

                this.countdownIntervalId = setInterval(() => {
                    console.log('Countdown:', this.countdown); // Debug log

                    if (this.countdown <= 0) {
                        clearInterval(this.countdownIntervalId);
                        this.countdownIntervalId = null;
                        this.endSession();
                        return;
                    }
                    this.countdown--;
                }, 1000);
            },
            promptToExtendSession() {
                console.log('Prompt to extend session'); // Debug log
                this.activityListenersActive = false; // Disable activity listeners during warning
                this.countdown = this.countdownSeconds; // Reset to 60
                this.showSessionWarning = true;
                this.displayCountdown();
            },
            refreshSession() {
                console.log('Refresh session - Continue clicked'); // Debug log
                this.clearTimers();

                // Call API to extend session
                try {
                    this.$api.user.extendSession();
                } catch (error) {
                    console.error('Error extending session:', error);
                }

                this.showSessionWarning = false;
                this.countdown = this.countdownSeconds; // Reset countdown
                this.activityListenersActive = true; // Re-enable activity listeners
                this.startSessionManager();
            },
            clearTimers() {
                if (this.countdownIntervalId) {
                    clearInterval(this.countdownIntervalId);
                    this.countdownIntervalId = null;
                }
                if (this.promptTimeoutId) {
                    clearTimeout(this.promptTimeoutId);
                    this.promptTimeoutId = null;
                }
            },
            startSessionManager() {
                // Clear any existing timers first
                this.clearTimers();

                const secondsBeforePrompt = this.sessionTimeout - this.countdownSeconds;
                console.log('Starting session manager, will prompt in', secondsBeforePrompt, 'seconds'); // Debug log

                this.promptTimeoutId = setTimeout(() => {
                    this.promptToExtendSession();
                }, secondsBeforePrompt * 1000);
            },
            handleUserActivity(event) {
                // Don't handle activity if warning is shown or listeners are disabled
                if (!this.activityListenersActive || this.showSessionWarning) {
                    return;
                }

                // Ignore clicks on the modal dialog elements
                if (event.target.closest('.modal-dialog')) {
                    return;
                }

                //console.log('User activity detected, extending session'); // Debug log
                this.clearTimers();

                // Call API to extend session
                //try {
                //    this.$api.user.extendSession();
                //} catch (error) {
                //    console.error('Error extending session:', error);
                //}

                // Restart the timer
                this.startSessionManager();
            }
        },
        mounted() {
            //console.log('Component mounted, session timeout:', this.sessionTimeout, 'seconds'); // Debug log
            this.startSessionManager();

            // Track user interactions with capture phase
            document.addEventListener('change', this.handleUserActivity, true);
            document.addEventListener('click', this.handleUserActivity, true);
            document.addEventListener('keypress', this.handleUserActivity, true);
        },
        beforeUnmount() {
            this.clearTimers();
            this.activityListenersActive = false;
            document.removeEventListener('change', this.handleUserActivity, true);
            document.removeEventListener('click', this.handleUserActivity, true);
            document.removeEventListener('keypress', this.handleUserActivity, true);
        }
    };
</script>

<style scoped>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }

    .modal-dialog {
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
        padding: 20px;
        width: 350px;
        max-width: 90%;
        position: relative;
        z-index: 10000;
    }

        .modal-dialog h2 {
            font-size: 1.3em;
            margin: 0 0 15px 0;
            text-align: center;
        }

        .modal-dialog p {
            margin: 10px 0;
            font-size: 0.95em;
        }

    .countdown-display {
        text-align: center;
        font-size: 1.5em;
        font-weight: bold;
        color: #d9534f;
        margin: 20px 0;
        padding: 15px;
        background-color: #f9f9f9;
        border-radius: 4px;
    }

    .button-container {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 20px;
    }

    .modal-dialog button {
        padding: 10px 20px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 0.95em;
        transition: background-color 0.2s;
        pointer-events: auto;
    }

    .btn-primary {
        background-color: #007acc;
        color: #fff;
    }

        .btn-primary:hover {
            background-color: #005f9d;
        }

    .btn-secondary {
        background-color: #6c757d;
        color: #fff;
    }

        .btn-secondary:hover {
            background-color: #545b62;
        }
</style>